<template>
  <v-container fluid class="pl-15 pr-10">
    <AuthCtrl :parm_step="5"></AuthCtrl>
    <div class="d-flex justify-center mt-5">
      <v-stepper flat class="d-flex" style="background: transparent">
        <v-stepper-step
          step="1"
          complete
          class="flex-column pr-0"
          color="#2CD8C5"
        >
          <v-btn
            flat
            color="white"
            class="mt-5 text-capitalize font-weight-bold titleText--text"
            style="
              box-shadow: 0px 4px 15px rgba(80, 93, 111, 0.1);
              border-radius: 10px;
            "
            small
            depressed
            >Seasonality & Decay</v-btn
          >
        </v-stepper-step>
        <div class="border__dashed"></div>
        <v-stepper-step step="2" class="flex-column px-0">
          <v-btn
            small
            depressed
            class="mt-5 ml-2 text-capitalize font-weight-bold titleText--text"
            @click="goTo('newvariablecreation')"
            >New variable creation</v-btn
          >
        </v-stepper-step>
        <div class="border__dashed"></div>
        <v-stepper-step step="3" class="d-flex flex-column pl-0">
          <v-btn
            depressed
            small
            class="mt-5 ml-2 text-capitalize font-weight-bold titleText--text"
            @click="onnextclick(),goTo('variabletransformation')"
            >Transformation</v-btn
          >
        </v-stepper-step>
      </v-stepper>
    </div>
    <div class="d-flex justify-space-between">
      <v-row>
        <v-col cols="9">
          <v-btn-toggle mandatory borderless color="blue">
            <v-btn height="36" small exact @click="onclickbtn(1)">
              <span class="text-capitalize font-weight-bold titleText--text"
                >Parameter</span
              >
            </v-btn>
            <v-btn height="36" small exact @click="onclickbtn(3)">
              <span class="text-capitalize font-weight-bold titleText--text"
                >Processed data</span
              >
            </v-btn>
          </v-btn-toggle> </v-col
        ><v-col cols="3">
          <div class="mt-5" v-if="this.bttype != 1">
            <v-select
              placeholder="Select region"
              hide-details="auto"
              style="border-radius: 8px; border: 2px solid #f3f5f8"
              dense
              solo
              flat
              v-model="dataregionSelected"
              :items="dataregion"
              @change="callRegionChangeEvent()"
              v-if="this.isregiosubnnational"
            ></v-select></div
        ></v-col>
      </v-row>
    </div>
    <v-row>
      <v-col></v-col>
    </v-row>
    <div v-if="bttype === 1">
      <v-card flat class="custom-shadow mt-5">
        <v-card-text>
          <v-row
            ><v-col cols="12">
              <div class="d-flex justify-start">
                <v-switch
                  inset
                  dense
                  hide-details="auto"
                  flat
                  color="#1976D2"
                  class="mt-0"
                  v-model="parm_season"
                  @click="ClickOnSessionVariable"
                >
                  <template v-slot:label>
                    <span class="titleText--text font-weight-bold"
                      >Create a seasonal variable</span
                    >
                  </template>
                </v-switch>
                <v-switch
                  inset
                  dense
                  hide-details="auto"
                  flat
                  color="#1976D2"
                  class="mt-0 ml-5"
                  v-model="parm_trend"
                  @click="ClickOnTrendVariable"
                >
                  <template v-slot:label>
                    <span class="titleText--text font-weight-bold"
                      >Create a trend variable</span
                    >
                  </template>
                </v-switch>
                <v-switch
                  inset
                  dense
                  hide-details="auto"
                  flat
                  color="#1976D2"
                  class="mt-0 ml-5"
                  v-model="parm_comp"
                  @click="ClickChkApplyDecayRate"
                >
                  <template v-slot:label>
                    <span class="titleText--text font-weight-bold"
                      >Find decay rate for promotional activities</span
                    >
                  </template>
                </v-switch>
              </div>
            </v-col></v-row
          >
          <div class="d-flex justify-center align-center mt-5" v-if="!showmsghide && parm_comp">
            <v-progress-circular color="blue" indeterminate />
          </div>
          <div v-else>
            <v-row>
                <div  class="my-5 d-flex">
                  <v-select
                  v-if="this.isregiosubnnational"
                    placeholder="Select region"
                    hide-details="auto"
                    style="border-radius: 8px; border: 2px solid #f3f5f8"
                    dense
                    solo
                    flat
                    v-model="dataregionSelectedfordecayrate"
                    :items="dataregion"
                    @change="callRegionChangeEventOnDecayrate()"
                  
                  ></v-select>
                
                </div>
                <v-btn
                  v-if="parm_comp"
                  class="mt-7 ml-3"
                  color="#d8e7f5"
                  depressed
                  @click="clickOnRecommended"
                >
                  <span class="titleText--text font-weight-medium">Recommended decay rate</span>
                </v-btn>
            </v-row>
            <v-row
              ><v-col>
                <div>
                  <v-row
                    v-for="element in this.listfind_decay_groupby_new"
                    :key="element.id"
                  >
                    <v-col cols="12"
                      ><ctrlfinddecayregion
                        :title="element.region"
                        :options="element.data"
                      ></ctrlfinddecayregion> </v-col
                  ></v-row>
                </div> </v-col
            ></v-row>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <div v-if="bttype === 3">
      <v-row>
        <v-col md="12">
          <ctrlgraphview
            ref="refgraphview"
            :title="dataregionSelected"
            :regionlist="listofregion"
          ></ctrlgraphview>
        </v-col>
        <v-col cols="12">
          <Ctrlgridview
            ref="refgridview"
            :title="dataregionSelected"
          ></Ctrlgridview>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="dialogrecommond" width="50%">
      <v-card height="auto">
        <v-card-title>
          <span class="titleText--text font-weight-bold">
            Recommended decay rate from TrigmaAI algorithm
          </span>
          <v-spacer />
          <v-btn icon color="titleText" text @click="dialogrecommond = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
          <v-simple-table fixed-header height="600">
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-center titleText--text font-weight-bold"
                    style="background: #f1f1f1"
                  >
                    Region
                  </th>
                  <th
                    class="text-center titleText--text font-weight-bold"
                    style="background: #f1f1f1"
                  >
                    Variable
                  </th>
                  <th
                    class="text-center titleText--text font-weight-bold"
                    style="background: #f1f1f1"
                  >
                    Estimate
                  </th>
                  <th
                    class="text-center titleText--text font-weight-bold"
                    style="background: #f1f1f1"
                  >
                    TValue
                  </th>
                  <th
                    class="text-center titleText--text font-weight-bold"
                    style="background: #f1f1f1"
                  >
                    Decay
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listfind_decay_recommended"
                  :key="item.region"
                >
                  <td class="text-center titleText--text">
                    {{ item.region }}
                  </td>
                  <td class="text-center titleText--text">
                    {{ item.variable }}
                  </td>
                  <td class="text-center titleText--text">
                    {{ item.estimate }}
                  </td>
                  <td class="text-center titleText--text">{{ item.tvalue }}</td>
                  <td class="text-center titleText--text">{{ item.decay }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import apifactory from "../api";

import apifactoryglobal from "../../../global/globalvar";
import globalclass from "../../../global/globalvar";
import mockdataQueryString from "../mockdata/baseQuerySting.json";
import AuthCtrl from "../../../components/AuthAction.vue";
//import CtrlNavButton from "../../../components/CtrbuttonSaveAndNext.vue";
import Ctrlfinddecayregion from "./ctrlfinddecayregion.vue";
import Ctrlgridview from "./ctrlSessionalitygridview.vue";
import ctrlgraphview from "./ctrlSessionalitygraphview.vue";

Vue.use(VueAxios, axios);
export default {
  components: {
    Ctrlgridview,
    ctrlgraphview,
    AuthCtrl,
    //CtrlNavButton,
    Ctrlfinddecayregion,
  },
  data: () => ({
    parmStore: [],
    parmurl: null,
    tempseriesdata: {
      name: "manish",
      data: [2, 3, 4, 5],
    },
    tbddata: [],
    tbddatakey: [],
    datacategories: [],
    dataitems: [],
    itemslog: [],

    e1: 4,
    bttype: 1,
    radioGroup: null,
    row: null,
    //for region
    dataregion: [],
    dataregionSelected: [],
    dataregionSelectedfordecayrate: [],
    isregiosubnnational: false,

    //for chart
    itemsplot: [],
    series: [],
    chartOptions: {
      chart: {
        id: "area-datetime",

        height: 350,
        zoom: {
          autoScaleYaxis: true,
        },
      },

      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
        style: "hollow",
      },

      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      legend: {
        show: true,
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],
        },
      },
    },

    xaxismin: null,
    xaxismax: null,
    //end for chart
    parm_step: 5,

    parm_zscore: 0,
    parm_bzscore: false,
    parm_subzscore: false,
    parm_trend: true,
    parm_season: true,
    parm_comp: false,

    parm_country: "india",
    parm_brand: "xyz",
    parm_level: "national",
    parm_time: "date",
    parm_sales_value: "sales",
    parm_sales_volume: "volume",
    parm_activity:
      "non_clm_call,clm_call,webinar,mass_email,email_1to1,phone_call",
    parm_competitor: "comp1",
    btdisabled: true,

    prevstepQueryStringParm: [],

    //new
    listofregion: [],
    showmsghide: false,
    listfind_decay: [],
    listfind_decay_groupby: [],
    listfind_decay_groupby_new: [],
    listfind_decay_data: [],
    itemlistsaveddecay: [],
    listfind_decay_filter: [],
    listfind_decay_recommended: [],
    dialogrecommond: false,
  }),

  methods: {
    callallsavemethods() {
      apifactory
        .callallsteps()
        .then((res) => {
          alert("callallsteps" + JSON.stringify(res));
        })
        .catch(function (error) {
          alert(error);
        });
    },
    goTo(url) {
      this.$router.push(url);
    },
    callRegionChangeEvent() {
      this.$refs.refgridview.refresh(this.dataregionSelected);
      this.$refs.refgraphview.refresh(this.dataregionSelected);
    },
    callRegionChangeEventOnDecayrate() {
      this.getdate_calldecay_filterdate();
    },
    clickOnRecommended() {
      this.dialogrecommond = true;
      this.listfind_decay_recommended = this.listfind_decay_filter.filter(
        (a) => a.TrigmaAI_Recommendation == "Recommended"
      );
    },
    clickCloseOnRecommended() {
      this.dialogrecommond = false;
    },
    ClickChkApplyDecayRate() {
      if (this.parm_comp) {
        this.showmsghide = true;
        this.getprojectregions();
        this.saveAndSetStep3();
        this.onnextclick();
        this.showmsghide = false;
      } else {
        this.saveAndSetStep3();
        this.showmsghide = false;
        this.listfind_decay = null;
      }
    },
    ClickOnSessionVariable() {
      this.saveAndSetStep3();
      this.onnextclick();
      // this.callallsavemethods();
    },
    ClickOnTrendVariable() {
      this.saveAndSetStep3();
      this.onnextclick();
    },

    get_saveed_channel_decay() {
      apifactory
        .call_getsaved_channel_decay()
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            let itemtemp = [];
            itemtemp = res.data;
            if (itemtemp.status == null) {
              this.itemlistsaveddecay = res.data;
            }
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    getsavedvalue(varregion, varvariable) {
      let outresult = 0;
      for (var k1 in this.itemlistsaveddecay) {
        if (k1 == varregion) {
          for (var k2 in this.itemlistsaveddecay[k1][0]) {
            if (k2 == varvariable) {
              outresult = this.itemlistsaveddecay[k1][0][k2];
            }
          }
        }
      }
      return outresult;
    },
    getprojectregions() {
      try {
        this.getdate_calldecay();
      } catch (error) {
        alert("getprojectregions-getdate_calldecay" + error);
      }
    },
    getdate_calldecay_old() {
      apifactory
        .callfind_decay()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            this.showmsghide = true;
            this.listfind_decay = [];
            for (let index = 0; index < res.data.decay_output.length; index++) {
              if (this.dataregionSelected == "national") {
                res.data.decay_output[index].region = "national";
              }
              res.data.decay_output[index].id = index + 1;
              if (this.itemlistsaveddecay.status != null) {
                res.data.decay_output[index].decayselected = this.getsavedvalue(
                  res.data.decay_output[index].region,
                  res.data.decay_output[index].variable
                );
              } else {
                res.data.decay_output[index].decayselected =
                  res.data.decay_output[index].decay;
              }
              res.data.decay_output[index].cuuregion =
                res.data.decay_output[index].region;
              res.data.decay_output[index].cuuval =
                res.data.decay_output[index].decayselected;
              res.data.decay_output[index].decayselectednew =
                this.getsavedvalue(
                  res.data.decay_output[index].region,
                  res.data.decay_output[index].variable
                );
              this.listfind_decay.push(res.data.decay_output[index]);
            }

            this.listfind_decay_groupby = this.groupBy(
              this.listfind_decay,
              "region"
            );
            let finaljson = [];
            let dataforfilter = [];
            if (this.listofregion.length > 0) {
              for (let index = 0; index < this.listofregion.length; index++) {
                dataforfilter = this.listfind_decay;
                let objregion = new Object();
                objregion.region = this.listofregion[index];
                objregion.data = dataforfilter.filter(
                  (a) => a.region == this.listofregion[index]
                );
                if (objregion.data.length > 0) {
                  finaljson.push(objregion);
                }
              }

              this.listfind_decay_groupby_new = finaljson;
            } else {
              dataforfilter = res.data.decay_output;
              let objregion = new Object();
              objregion.region = "national";
              objregion.data = dataforfilter;
              finaljson.push(objregion);
              this.listfind_decay_groupby_new = finaljson;
            }
          }
        })
        .catch(function (error) {
          alert("getdate_calldecay" + error);
        });
    },
    getdate_calldecay() {
      apifactory
        .callfind_decay()
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.showmsghide = true;
            this.listfind_decay_filter = res.data.decay_output;
            this.getdate_calldecay_filterdate();
          }
        })
        .catch(function (error) {
          alert("getdate_calldecay" + error);
        });
    },
    getdate_calldecay_filterdate() {
      let inputlist = [];
      inputlist = this.listfind_decay_filter;
      this.showmsghide = true;
      let tempinputlistdata = [];
      tempinputlistdata = inputlist.filter(
        (a) => a.region == this.dataregionSelectedfordecayrate
      );
      this.listfind_decay = [];
      for (let index = 0; index < tempinputlistdata.length; index++) {
        if (this.dataregionSelected == "national") {
          tempinputlistdata[index].region = "national";
        }
        tempinputlistdata[index].id = index + 1;
        if (this.itemlistsaveddecay.status != null) {
          tempinputlistdata[index].decayselected = this.getsavedvalue(
            tempinputlistdata[index].region,
            tempinputlistdata[index].variable
          );
        } else {
          tempinputlistdata[index].decayselected =
            tempinputlistdata[index].decay;
        }
        tempinputlistdata[index].cuuregion = tempinputlistdata[index].region;
        tempinputlistdata[index].cuuval =
          tempinputlistdata[index].decayselected;
        tempinputlistdata[index].decayselectednew = this.getsavedvalue(
          tempinputlistdata[index].region,
          tempinputlistdata[index].variable
        );
        this.listfind_decay.push(tempinputlistdata[index]);
      }

      this.listfind_decay_groupby = this.groupBy(this.listfind_decay, "region");
      let finaljson = [];
      let dataforfilter = [];
      if (this.listofregion.length > 0) {
        for (let index = 0; index < this.listofregion.length; index++) {
          dataforfilter = this.listfind_decay;
          let objregion = new Object();
          objregion.region = this.listofregion[index];
          objregion.data = dataforfilter.filter(
            (a) => a.region == this.listofregion[index]
          );
          if (objregion.data.length > 0) {
            finaljson.push(objregion);
          }
        }

        this.listfind_decay_groupby_new = finaljson;
      } else {
        dataforfilter = tempinputlistdata;
        let objregion = new Object();
        objregion.region = "national";
        objregion.data = dataforfilter;
        finaljson.push(objregion);
        this.listfind_decay_groupby_new = finaljson;
      }
    },
    groupBy: function (array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    getdisyinctitems(MYJSON, prop) {
      return MYJSON.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    addKeyValue(obj, key, data) {
      obj[key] = data;
    },
    changeval1() {
      this.parm_bzscore = false;
      this.parm_subzscore = false;
    },
    changeval(event) {
      if (parseInt(this.parm_zscore) == 0) {
        this.parm_bzscore = false;
        event.preventDefault();
        return false;
      }
    },
    onclickbtn(varbttype) {
      this.bttype = varbttype;

      if (varbttype === 1) {
        this.btdisabled = true;
      }
    },
    onPreviewclick() {
      this.saveAndSetStepParms(0);
      this.getdata();
      this.getplot();
      this.getlog();
      this.btdisabled = false;
    },

    onnextclick() {
      this.callApi_call_save_step3();
    },
    onBackclick() {
      this.$router.push("/edaanalysis");
    },

    callApi_call_save_step3() {
      apifactory
        .call_save_step3()
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.callApi_call_save_step4();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
callApi_call_save_step4() {
      apifactory
        .call_save_step4()
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.callApi_call_save_step5();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    callApi_call_save_step5() {
      apifactory
        .call_save_step5()
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.saveAndSetStep3_OnNextClick();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    saveAndSetStep3() {
      let url_querystring =
        "trend=" +
        apifactoryglobal.convertbooltoint(this.parm_trend) +
        "&season=" +
        apifactoryglobal.convertbooltoint(this.parm_season) +
        "&decay=" +
        apifactoryglobal.convertbooltoint(this.parm_comp) +
        "";

      apifactory
        .addParameterBySteps("3", url_querystring)
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    saveAndSetStep3_OnNextClick() {
      let url_querystring =
        "trend=" +
        apifactoryglobal.convertbooltoint(this.parm_trend) +
        "&season=" +
        apifactoryglobal.convertbooltoint(this.parm_season) +
        "&decay=" +
        apifactoryglobal.convertbooltoint(this.parm_comp) +
        "";

      apifactory
        .addParameterBySteps("3", url_querystring)
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.SaveStep_5();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    SaveStep_5() {
      let url_querystring = "test=0";
      apifactory
        .addParameterBySteps("5", url_querystring)
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.SaveStep_6();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    SaveStep_6() {
      let url_querystring = "test=0";
      apifactory
        .addParameterBySteps("6", url_querystring)
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            this.saveAndSetNext_OnNextClick();
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },
    saveAndSetNext_OnNextClick() {
      let url_querystring = "apply_ads_activity=0&apply_ads_base=0";
      apifactory
        .addParameterBySteps("7", url_querystring)
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          }
          /*else {
           
            this.$router.push("/newvariablecreation");
          }*/
        })
        .catch(function (error) {
          alert(error);
        });
    },
    saveAndSetStepParms(varclickfrom) {
      if (parseInt(this.parm_zscore) == 0) {
        this.parm_bzscore = false;
        this.parm_subzscore = false;
      }
      let url_querystring =
        "zscore=" +
        this.parm_zscore +
        "&bzscore=" +
        apifactoryglobal.convertbooltoint(this.parm_bzscore) +
        "&subzscore=" +
        apifactoryglobal.convertbooltoint(this.parm_subzscore) +
        "&trend=" +
        apifactoryglobal.convertbooltoint(this.parm_trend) +
        "&season=" +
        apifactoryglobal.convertbooltoint(this.parm_season) +
        "&comp=" +
        apifactoryglobal.convertbooltoint(this.parm_comp) +
        "";
      apifactory
        .addParameterBySteps(globalclass.PARAM_Step_MDP_S, url_querystring)
        .then((res) => {
          if (res.status != 200) {
            alert("Sorry");
          } else {
            if (varclickfrom === 1) {
              this.$store.commit("ModelDataPreparation/ADD_ITEM", 1);
              this.$router.push("/adstockdecay");
            }
          }
        })
        .catch(function (error) {
          alert(error);
        });
    },

    storeparmInStorage() {
      let obj = new Object();
      obj.name = "parm_bzscore";
      obj.value = this.parm_bzscore;
      this.parmStore.push(obj);
    },
    getdata() {
      apifactory
        .getseasonalitydata()
        .then((res) => {
          if (res.status != 200) {
            this.dataitems = null;
          } else {
            this.dataitems = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getlog() {
      apifactory
        .getseasonalitydatalog(
          this.parm_step,
          this.parm_zscore,
          this.parm_bzscore,
          this.parm_subzscore,
          this.parm_trend,
          this.parm_season,
          this.parm_comp
        )
        .then((res) => {
          if (res.status != 200) {
            this.itemslog = null;
          } else {
            this.itemslog = res.data;
            for (var i = 0; i < res.data.length; i++) {
              var obj = res.data[i].step;
              this.tbddata.push(obj);
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getplot() {
      apifactory
        .getseasonalityplot(
          this.parm_country,
          this.parm_brand,
          this.parm_level,
          this.parm_time,
          this.parm_sales_value,
          this.parm_sales_volume,
          this.parm_activity,
          this.parm_competitor,
          this.parm_step,
          this.parm_zscore,
          this.parm_bzscore,
          this.parm_subzscore,
          this.parm_trend,
          this.parm_season,
          this.parm_comp
        )
        .then((res) => {
          if (res.status != 200) {
            this.itemsplot = null;
          } else {
            this.itemsplot = res.data;
            this.getchartseries();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    generateSeriesd_volume() {
      var series = [];
      for (var i = 0; i < this.itemsplot.length; i++) {
        var obj = this.itemsplot[i].d_volume;
        series.push(obj);
      }
      return series;
    },
    generateSeriess_season() {
      var series = [];
      for (var i = 0; i < this.itemsplot.length; i++) {
        var obj = this.itemsplot[i].s_season;
        series.push(obj);
      }
      return series;
    },
    generateSeriess_trend() {
      var series = [];
      for (var i = 0; i < this.itemsplot.length; i++) {
        var obj = this.itemsplot[i].s_trend;
        series.push(obj);
      }
      return series;
    },
    getallkeyold() {
      var keys = [];
      for (var k in this.itemsplot[0]) {
        if (k != "t_date") {
          keys.push(k);
        }
      }
      this.tbddatakey = keys;
    },
    getallkey() {
      var keys = [];
      var tkey = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "t_date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            keysdata.push(this.itemsplot[i][k1]);
          }
          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      this.tempseriesdata = [];
      this.tempseriesdata = tkey;
      this.tbddatakey = keys;
    },
    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "t_date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].t_date).getTime());
            var innerdata = [];

            innerdata.push(new Date(this.itemsplot[i].t_date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }

      this.series = [];
      this.series = tkey;

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            type: "datetime",
            min: mindate,
            tickAmount: 6,
          },
          annotations: {
            yaxis: [
              {
                y: 0,
                borderColor: "#999",
                label: {
                  show: true,
                  // text: 'Support',
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#00E396",
                  },
                },
              },
            ],
            xaxis: [
              {
                x: mindate,
                borderColor: "#999",
                yAxisIndex: 0,
                label: {
                  show: true,
                  // text: 'XAxis Data',
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#775DD0",
                  },
                },
              },
            ],
          },
        },
      };
    },
    convertbooltoint(varbool) {
      //alert(varbool);
      //result ? 1 : 0;
      let ivalue = varbool ? 1 : 0;

      return ivalue;
    },
    convertinttoboll(varint) {
      //alert(varbool);
      //result ? 1 : 0;
      if (varint == 1) {
        return true;
      } else {
        return false;
      }
    },
    getSavedParametrOfthisStep() {
      this.parmStore = [];
      apifactory
        .gettheParameterByProjectStep("3")
        .then((res) => {
          if (res.status != 200) {
            this.parmStore = [];
          } else {
            this.parmStore = res.data;
            this.parm_season = this.convertinttoboll(this.parmStore["season"]);
            this.parm_trend = this.convertinttoboll(this.parmStore["trend"]);
            this.parm_comp = this.convertinttoboll(this.parmStore["decay"]);
            this.ClickChkApplyDecayRate();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = mockdataQueryString;
      let strurl = "";
      for (var k in this.prevstepQueryStringParm) {
        //alert(k);
        if (k != "step") {
          strurl = strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
          //alert(this.prevstepQueryStringParm[k]);
        }
      }
      strurl = strurl.slice(0, -1);
      //alert(strurl);
      this.prevstepQueryStringParm = strurl;
    },
    getprojectregionsonload() {
      this.listofregion = [];
      apifactory
        .call_get_project_region_list()
        .then((res) => {
          if (res.status != 200) {
            // return false;
            alert("Sorry");
          } else {
            if (res.data.length == 0) {
              this.isregiosubnnational = false;
              this.listofregion.push("national");
              this.dataregionSelected = this.listofregion[0];
              this.dataregionSelectedfordecayrate = this.listofregion[0];
              this.callRegionChangeEventOnDecayrate();
            } else {
              this.isregiosubnnational = true;
              this.listofregion = res.data.filter((a) => a != "national");
              this.dataregionSelected = this.listofregion[0];
              this.dataregionSelectedfordecayrate = this.listofregion[0];
            }
            this.dataregion = this.listofregion;
            //alert("data:-" + JSON.stringify(this.isregiosubnnational));
          }
        })
        .catch(function (error) {
          alert("getprojectregions" + error);
          // return false;
        });
    },
  },
  computed: {
    msgwait: function () {
      if (this.parm_comp) {
        return "loading....";
      } else {
        return "";
      }
    },
  },
  mounted() {
    // this.getprojectregions();
    //this.getParametrOfPrvStep();
    this.getprojectregionsonload();
    this.get_saveed_channel_decay();
    this.getSavedParametrOfthisStep();
  },
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}

.errorlog {
  background-color: rgba(255, 0, 0, 0.274);
  color: black;
}

.nonerrorlog {
  background-color: rgba(0, 128, 0, 0.377);
  color: black;
}
.customselectbox {
  padding-top: 10px !important;
  width: 80% !important;
}

.border__dashed {
  border: 1px dashed #505d6f;
  opacity: 0.4;
  height: 0px;
  width: 100px;
  margin-top: 5%;
}

table td {
  border-bottom: 1px solid #f1f1f1 !important
}

table thead,
table tr {
  border-bottom: 1px solid #f1f1f1 !important
}
</style>
